module.exports = __webpack_public_path__ + "img/About-Pic.582e2c8c.jpeg";